import * as React from 'react'
import { Eye } from 'lucide-react'
import { StatusPill } from '@/components/ui/status-pill'
import { useT } from '@/components/visitone/visitone-provider'
import type { AccessPill as AccessPillKind, PageStatus } from '@/lib/access'

/*
 * Access pills (VIS-329): text plus an `aria-hidden` icon, never colour alone.
 * View only is info + eye. They go in `PageHeader.status`.
 */
const PILLS: Record<AccessPillKind, { tone: 'info'; icon: React.ReactNode; labelKey: string }> = {
  viewOnly: { tone: 'info', icon: <Eye aria-hidden="true" />, labelKey: 'core.access.viewOnly' },
}

export function AccessPill({ kind }: { kind: AccessPillKind }) {
  const t = useT()
  const pill = PILLS[kind]
  return (
    <StatusPill tone={pill.tone} icon={pill.icon}>
      {t(pill.labelKey)}
    </StatusPill>
  )
}

/** The pills a `pageStatus` result puts in `PageHeader.status`, or nothing. */
export function AccessPills({ status }: { status: Pick<PageStatus, 'pills'> }) {
  if (status.pills.length === 0) return null
  return (
    <>
      {status.pills.map((kind) => (
        <AccessPill key={kind} kind={kind} />
      ))}
    </>
  )
}
